import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import Search from '@/components/Search'
import Guide from '@/components/Guide'
import Contact from '@/components/Contact'
import NotFound from '@/components/NotFound'

require('es6-promise').polyfill()

Vue.use(Router)
Vue.use(Meta)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: {
        name: 'Search',
        query: { query: '笑顔' }
      }
    },
    {
      path: '/search',
      name: 'Search',
      component: Search
    },
    {
      path: '/guide',
      name: 'Guide',
      component: Guide
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '*',
      component: NotFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js